import React, { useState } from "react";

import PropTypes from "prop-types";

import DataTable from "../DataTable";

import { ALL_CUSTOMERS_QUERY } from "../../graphql/Customers/Customers.graphql";

import { CUSTOMER_COLUMNS } from "../../pages/Accounting/Customers/columns";

import { CustomerFilters } from "../filters";

const CustomerGridSelect = ({ where = {}, onRowClick }) => {
  const [filters, setFilters] = useState(() => where);

  return (
    <div className="modal-grid-select">
      <CustomerFilters filters={filters} onChange={setFilters} />
      <DataTable
        columns={CUSTOMER_COLUMNS}
        dataQuery={ALL_CUSTOMERS_QUERY}
        initialSortBy={[{ id: "CustomerNo", desc: false }]}
        name="Customer"
        where={filters}
        onRowClick={onRowClick}
      />
    </div>
  );
};

CustomerGridSelect.propTypes = {
  where: PropTypes.object,
  onRowClick: PropTypes.func
};

export default CustomerGridSelect;
